export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-ease/src/linear.js
// module id = GNlZ
// module chunks = 0